import { useQuery } from '@tanstack/react-query'
import { t } from 'i18next'

import Panel from '~/components/Panel'
import Status from '~/components/Status'

import {
  getCampaignPermissionsService,
  getCampaignPermissionsServiceKey
} from '../../services/configuration/campaign-permissions'
import FormEditDailyCost from './FormEditDailyCost'

import * as S from './styles'

export const DailyCost = ({ data }: ViewCampaignProps) => {
  // O painel só aparece para publishers com `allow_daily_cost_campaign`.
  // Em qualquer outro cenário, o componente devolve null mesmo se for montado.
  const publisherId = data?.publisher?.id

  const { data: campaignPermissions } = useQuery({
    queryKey: [getCampaignPermissionsServiceKey, { publisher_id: publisherId }],
    queryFn: async () => {
      const response = await getCampaignPermissionsService({
        publisher_id: publisherId
      })

      return response?.data
    },
    enabled: !!publisherId
  })

  if (!campaignPermissions?.allow_daily_cost_campaign) return null

  return (
    <Panel>
      <S.WrapperStatus className="mb-2">
        <S.TitleStrong>{t('rm:DailyCost')}</S.TitleStrong>

        <Status label={t('rm:dailyCost.status.text')} template="info" />
      </S.WrapperStatus>

      <FormEditDailyCost data={data} />
    </Panel>
  )
}
